import { emailRegex, whitespaceRegex } from './regex';

/**
 * Validates email inputs if there duplicates, invalid inputs or more than the specified limit
 * @param {string} input raw email input
 * @param {number} limit Max number of emails to validate
 * @returns {Object} returns an object with email validations
 */
export const validateEmails = (input: string, limit: number = 25) => {
  const emails = input
    .replace(whitespaceRegex, '')
    .split(/,|;|\n/)
    .filter(s => s !== '');
  const validLimit = emails.length <= limit;

  const validEmails = emails.filter(email => emailRegex.test(email));
  const invalidEmails = emails.filter(email => !emailRegex.test(email));

  const isValid = validEmails.length === emails.length;

  return { validLimit, isValid, validEmails, invalidEmails };
};

// Form errors i18n keys
export const FormErrorKeys = {
  TOO_MANY_EMAILS: 'InviteUsersModal.Errors.TOO_MANY_EMAILS',
  INVALID_EMAIL: 'InviteUsersModal.Errors.INVALID_EMAIL',
};
